import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ILearnActionRepository } from '../../repositories/interfaces/iLearnActionRepository';
import { IContentLikeDislikePayload } from '../../../entity/interface/iLearnAction';
import ResponseError from '../../entities/errors/ResponseError';
import { APIPath } from '@intigral/constant';

export interface IAddLikeDislikeUseCase {
    execute(apiKey: string, paylod: IContentLikeDislikePayload, identityToken: string): Promise<any>;
}

export class AddLikeDislikeUseCase implements IAddLikeDislikeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get addLikeDislikeRepository(): ILearnActionRepository {
        return container.resolve<ILearnActionRepository>(DI.REPOSITORIES.ILearnActionRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, paylod: IContentLikeDislikePayload, identityToken: string): Promise<any> {
        const response = await this.addLikeDislikeRepository.addLikeDislike(apiKey, paylod, identityToken);
        if (typeof response.data !== 'undefined') {
            return true;
        }
        if (typeof response.error !== 'undefined') {
            throw new ResponseError(
                { url: APIPath.CONTENT_LIKE_DISLIKE_RATING },
                {
                    code: response.error.code || 0,
                    message: response.error.msg || 'Unknown error',
                }
            );
        }
        return false;
    }
}
